import React, { useMemo } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { withWidth, isWidthUp } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import cx from 'classnames';

import useStyles from './styles';
import { ExpertsSlider } from '../ExpertsSlider';

export const ExpertsBlock = ({ data: expertsData, width }) => {
  const isMobile = !isWidthUp('sm', width);
  const background = expertsData?.background;
  const heading = expertsData?.heading;
  const description = expertsData?.description;
  const items = useMemo(() => {
    return expertsData?.items
      ? expertsData.items.map((item) => item?.expert).filter((item) => item)
      : [];
  }, [expertsData]);
  const classes = useStyles(background)();

  return (
    <Box
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'experts-block',
      )}
    >
      <Container className={classes.container}>
        <div className={classes.content}>
          <Box className={classes.headingWrapper}>
            <Typography variant="h2" component="h2" align="center" className={classes.heading}>
              {heading}
            </Typography>
            <Typography className={classes.description}>{description}</Typography>
          </Box>

          <ExpertsSlider
            experts={items}
            tileType={background === 'Light' && !isMobile ? 'dark' : 'light'}
            withLinks
          />
        </div>
      </Container>
    </Box>
  );
};

export default withWidth()(ExpertsBlock);
